import { LibraryPostFileClickAction } from "_constants/GlobalConstants";
import { LibraryPostType } from "_constants/LibraryConstants";
import { FileHelper } from "_helpers/FileHelper";
import { isMobile } from "react-device-detect";
import { trackPromise } from "react-promise-tracker";
import { LibraryApi } from "services/library.service";

export const LibraryHelper = {
    filterCategoryByTag,
    hasDynamicUrlPermission,
    openLibraryNoticeDialog,
    handleLibraryPostOnClick,
    handleLibraryPostUrlOnClick,
    getCheckedTags,
    applyFiltersToPayload,
};

function filterCategoryByTag(checkedTags, categoryList) {
    if (checkedTags.length > 0) {
        return categoryList
            .filter((c) => c.libraryPosts && c.libraryPosts.length > 0)
            .map((c) => ({
                ...c,
                libraryPosts: c.libraryPosts.filter(
                    (p) =>
                        p.libraryPostLibraryTags.length > 0 &&
                        p.libraryPostLibraryTags.some(
                            (pt) => checkedTags.indexOf(pt.libraryTag.name) !== -1
                        )
                ),
            }))
            .filter((sub) => sub.libraryPosts && sub.libraryPosts.length > 0);
    }
    return categoryList;
}

function hasDynamicUrlPermission(post, user) {
    let hasPermission = false;
    hasPermission =
        (post && post.type != 2) ||
        (post &&
            post.type == 2 &&
            post.libraryPostUrl &&
            !post.libraryPostUrl.isDynamicUrl) ||
        (post &&
            post.type == 2 &&
            post.libraryPostUrl &&
            post.libraryPostUrl.isDynamicUrl &&
            user.isSuperAdmin);
    return hasPermission;
}

function openLibraryNoticeDialog(setNoticeDialog, noticeDialog, notice, data) {
    setNoticeDialog({
        ...noticeDialog,
        title: "Notice",
        type: "info",
        message: notice,
        open: true,
        id: "library-notice",
        data: data,
        confirmButtonText: "Ok",
    });
}

function handleLibraryPostOnClick({ postId, postType, action }) {
    if (postType === LibraryPostType.File) {
        handleLibraryPostFileOnClick(postId, action);
    } else if (postType === LibraryPostType.Url) {
        handleLibraryPostUrlOnClick(postId);
    }
}

function handleLibraryPostFileOnClick(postId, action) {
    if (action === LibraryPostFileClickAction.Download) {
        downloadLibraryPostFile(postId);
    } else if (action === LibraryPostFileClickAction.Open) {
        openLibraryPostFile(postId);
    }
}

function getCheckedTags(tagItems) {
    return tagItems
        .filter((tag) => tag.checked)
        .map((filteredTag) => filteredTag.name);
}

function applyFiltersToPayload(payload, filters) {
    if (filters == null || filters.length === 0) {
        return payload;
    }
    let filtersSet = new Set(filters);        
    let updatedTagItems = [
        ...(payload.tags.items).map((item) => ({
            ...item,
            checked: filtersSet.has(item.name),
        })),
    ];
    let checkedTags = LibraryHelper.getCheckedTags(updatedTagItems);
    
    payload.categories = LibraryHelper.filterCategoryByTag(checkedTags, payload.categories);
    payload.tags.items = updatedTagItems;

    return payload;
}

function downloadLibraryPostFile(postId) {
    trackPromise(
        LibraryApi.downloadFile(postId)
            .then((response) => FileHelper.DownloadFile(response))
            .catch((error) => console.log(error))
    );
}

function openLibraryPostFile(postId) {
    trackPromise(
        LibraryApi.downloadFile(postId)
            .then((response) => FileHelper.ViewFileFromResponse(response))
            .catch((error) => console.log(error))
    );
}

function handleLibraryPostUrlOnClick(postId) {
    if (isMobile) {
        openLibraryPostUrlInMobile(postId);
    } else {
        openLibraryPostUrl(postId);
    }
}

function openLibraryPostUrl(postId) {
    LibraryApi.renderLink(postId)
        .then((response) => {
            var windowReference = window.open();
            windowReference.opener = null;
            windowReference.location = response.data;
        })
        .catch((err) => console.log(err));
}

function openLibraryPostUrlInMobile(postId) {
    LibraryApi.renderLink(postId)
        .then((response) => {
            window.location.href = response.data;
        })
        .catch((err) => console.log(err));
}